<template>
    <span>
        <slot name="before-button"/>
        <b-button v-b-tooltip.noninteractive.hover.top
                  :class="ButtonInsideClass"
                  :disabled="
                        ((FeatureName !== undefined && FeatureName !== '') || (Action !== undefined && Action !== '') 
                            ? !$store.getters['CheckAction'](Parameters?.Right, FeatureName, Action)
                            : true) 
                        && Disabled"
                  :title="Tooltip != undefined && Tooltip != '' ? Tooltip : $t(Parameters?.Tooltip)"
                  :variant="Outline ? `outline-${Variant}` : Variant"
                  class="btn-circle border-0"
                  v-on="$listeners">
            <slot name="before-icon"/>
            <slot name="icon">
                <b-icon v-if="Parameters?.Icon" :class="IconClass"
                        :icon="Parameters?.Icon"/>
            </slot>
            <slot name="after-icon"/>
        </b-button>
        <slot name="after-button"/>
    </span>
</template>

<script lang="ts">
import {Component, Prop} from 'vue-property-decorator';
import ButtonIcon from "../ButtonIcon";
import IButtonParameters from '../../IButtonParameters'
import IconParameters from "./ButtonIconSimpleParameters";

@Component({
    i18n: ButtonIcon.MessageLocales()
})
export default class ButtonIconComplexe extends ButtonIcon {
    @Prop({default: () => ""})
    public Type!: string;

    @Prop({
        default: () => {
        }
    })
    public ParametersOverride!: IButtonParameters;

    get Parameters(): IButtonParameters {
        // Si la prop de surcharge a �t� pass�e, on l'utilise.
        if (this.ParametersOverride) {
            return this.ParametersOverride;
        }

        // Sinon, on utilise la valeur par d�faut
        return new IconParameters(this.Right, {icon: '', tooltip: this.Tooltip});
    }

    constructor() {
        super();
    }
}
</script>

<style scoped>
</style>